import api from '@functions/api'

import { handleError } from '../utils'

const CREATE_REQUEST = 'contenthouse/serviceJobSendToEsoft/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/serviceJobSendToEsoft/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/serviceJobSendToEsoft/CREATE_FAILURE'

// Initial State
const initialState = {
    errors: [],
    loaded: false,
    loading: false,
    creating: false,
  }

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function postServiceJobSendToEsoft(serviceJobId, options){
  const config = {
    method: 'POST',
    data: options,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api(`/v1/service-jobs/${serviceJobId}/send-to-esoft`, options, config)
      .then(() => {
        dispatch(createSuccess())
        return { success: true, data: {} }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

export default function reducer(state = initialState, action = {}){
  const { additionalInfo, type, errors, loadedForKeys, loadedIds, results } = action

  switch (type){
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
